import { TileLayer } from "deck.gl";
import { hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions";
import { PMTiles } from 'pmtiles'
import { MVTLoader } from "@loaders.gl/mvt";
import { parse } from "@loaders.gl/core";

export function BuildingPopulationLayer(workspace, layerName, is3D, opacity, zoom, dataSource) {
        const pmtiles = new PMTiles(dataSource)

        return (
                new TileLayer({
                        id: 'BuildingPopulationLayer',
                        data: null,
                        getTileData: async (tile) => {
                                const { x, y, z } = tile.index;
                                const res = await pmtiles.getZxy(z, x, y);
                                const data = res.data ? new Uint8Array(res.data) : new Uint8Array();
                                return parse(data, MVTLoader, {
                                        loadOptions: { worker: true },
                                        mvt: {
                                                coordinates: "wgs84",
                                                tileIndex: { x, y, z },
                                        },
                                });
                        },
                        tileSize: 256,
                        onTileLoad: showLoading,
                        onViewportLoad: hideLoading,
                        opacity: opacity / 100,
                        stroked: true,
                        filled: true,
                        maxZoom: 15,
                        getFillColor: f => {
                                const p = f.properties.population
            
                                if (p <= 5) {
                                    return [253, 206, 187]
                                }
                                if (p <= 10) {
                                    return [252, 188, 164]
                                }
                                if (p <= 15) {
                                    return [252, 153, 123]
                                }
                                if (p <= 20) {
                                    return [252, 148, 117]
                                }
                                if (p <= 25) {
                                    return [255, 130, 99]
                                }
                                if (p <= 30) {
                                    return [251, 107, 76]
                                }
                                if (p <= 50) {
                                    return [237, 71, 54]
                                }
                                if (p <= 100) {
                                    return [226, 46, 38]
                                }
                                if (p <= 150) {
                                    return [203, 33, 32]
                                }
            
                                return [184, 22, 26]
                            },
                            getLineColor: f => {
                                const p = f.properties.population
            
                                if (p <= 5) {
                                    return [253, 206, 187]
                                }
                                if (p <= 10) {
                                    return [252, 188, 164]
                                }
                                if (p <= 15) {
                                    return [252, 153, 123]
                                }
                                if (p <= 20) {
                                    return [252, 148, 117]
                                }
                                if (p <= 25) {
                                    return [255, 130, 99]
                                }
                                if (p <= 30) {
                                    return [251, 107, 76]
                                }
                                if (p <= 50) {
                                    return [237, 71, 54]
                                }
                                if (p <= 100) {
                                    return [226, 46, 38]
                                }
                                if (p <= 150) {
                                    return [203, 33, 32]
                                }
            
                                return [184, 22, 26]
                            },
                        getLineWidth: 1.0,
                        lineWidthMinPixels: 1.0,
                        pickable: true,
                        getElevation: is3D ? d => d.properties.height : 0,
                        terrainDrawMode: is3D ? 'offset' : '',
                        extruded: is3D,
                        extensions: is3D
                                ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                                : [new DataFilterExtension({ filterSize: 1 })],

                        visible: true,
                        dataComparator: (a, b) => false
                })
        )
}

        